import React, { useState } from "react";
import { SmartFilter } from "./types";
import { RadioGroup, RadioGroupItem } from "../ui/RadioGroup";
import { Label } from "../ui/Label";
import { Button } from "../ui";
import { useTranslation } from "react-i18next";

export const SmartFilterPopup = ({
  smartFilter,
  onApply,
  initialValue,
}: {
  smartFilter: SmartFilter;
  initialValue: string | null;
  onApply: (value: string | null) => void;
}) => {
  const [value, setValue] = useState<string | null>(initialValue);

  const isDirty = value !== initialValue;

  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4">
      <div className="leading-5 font-semibold text-dark-gray">
        {smartFilter.name}
      </div>
      <div>
        {smartFilter.subtitle && (
          <div className="mb-2 leading-[140%] font-medium">
            {smartFilter.subtitle}
          </div>
        )}
        <RadioGroup value={value}>
          {smartFilter.options.map((opt) => {
            return (
              <div key={opt.value} className="flex space-x-2">
                <RadioGroupItem
                  className="mt-[1px] size-4.5 border-black dark:border-white"
                  iconClass="size-3"
                  onClick={() =>
                    setValue((prev) => (prev !== opt.value ? opt.value : null))
                  }
                  value={opt.value}
                  id={opt.label}
                />
                <Label
                  className="leading-[140%] font-normal"
                  htmlFor={opt.label}
                >
                  {opt.label}
                </Label>
              </div>
            );
          })}
        </RadioGroup>
      </div>
      <Button
        onClick={() => onApply(value)}
        disabled={!isDirty}
        className="rounded-sm text-secondary"
      >
        {t("smartFilters.applyFilters")}
      </Button>
    </div>
  );
};
